import React, { useState } from 'react'
import './LandingPage.css'
import SwitchSelector from 'react-switch-selector'
import SwipeableViews from 'react-swipeable-views'
import Login from '../../component/landingPage/Login'
import Signup from '../../component/landingPage/Signup'

function LandingPage() {
  const [index, setIndex] = useState(0)

  const styles = {
    slide: {
      margin: 0,
      height: '90vh',
      width: '90vw',
      position: 'relative',
    },
    slide1: {
      backgroundColor: '#FCF3CF ',
      backgroundImage: ' linear-gradient(to right, #FFD166, #FFFCF9)',

      zIndex: 2,
    },
    slide2: {
      backgroundColor: '#F4ECF7 ',
      backgroundImage: ' linear-gradient( to right, #f4c4f3 , #fc67fa )',
    },
  }

  const options = [
    {
      label: 'Login',
      value: 0,
      selectedBackgroundColor: '#ff5900',
    },
    {
      label: 'Signup',
      value: 1,
      selectedBackgroundColor: '#ab00b3 ',
    },
  ]

  const handleSwitchChange = (newValue) => {
    setIndex(newValue)
  }

  const handleIndexChange = (index) => {
    setIndex(index)
  }

  const initialSelectedIndex = options.findIndex(({ value }) => value === 0)

  return (
    <>
    <div className='landing-page-container '>
      <div className='switch-style no-select'>
        <SwitchSelector
          onChange={handleSwitchChange}
          options={options}
          initialSelectedIndex={initialSelectedIndex}
          backgroundColor={'#353b48'}
          fontColor={'#f5f6fa'}
        />
      </div>
      <SwipeableViews index={index} onChangeIndex={handleIndexChange} disabled>
        <div style={Object.assign({}, styles.slide, styles.slide1)}>
          <Login />
        </div>
        <div style={Object.assign({}, styles.slide, styles.slide2)}>
          <Signup />
        </div>
      </SwipeableViews>

    </div>
    <div className='credit-section no-select'>Credited to Lee Yuan Hooi (136178), USMCS2020</div>

    </>
  )
}

export default LandingPage
